<template>
  <img
    class="object-contain"
    :class="[
      $attrs.class ? $attrs.class : 'h-14'
    ]"
    alt="KPF2Pay logo"
    src="@/assets/image/logo-cryptopay.svg"
  />
</template>